import { ITreatmentBeforeOperationPasireotide } from './TreatmentBeforeOperationPasireotide.types';

export const initialTreatmentBeforeOperationPasireotide: ITreatmentBeforeOperationPasireotide = {
  dose: '',
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}